import EntityRecordUI from './EntityRecordUI';

export default EntityRecordUI;

